import { api } from './_init'


export const fetchCustomPrompt = async () => {
  try{
    const result = await api.get('prompts/custom_prompt')

    if (result.status === 200) {
      return {
        success: true,
        data: result.data,
      }
    } else {
      return {
        success: false,
        error: result.data,
      }
    }
  } catch(error){
    return {
      success: false,
      error: error.message,
    }
  }
}

export const createCustomPrompt = async ({prompt, custom_prompt_enabled}) => {
  try {
    const result = await api.post('prompts/custom_prompt', { prompt, custom_prompt_enabled })

    if (result.status === 200 || result.status === 204 || result.status === 201) {
      return {
        success: true,
        data: result.data,
      }
    } else {
      return {
        success: false,
        error: result.data,
      }
    } 
  } catch (error) {
    return {
      success: false,
      error: error.message,
    }
  }
}


export const updateCustomPrompt = async ({prompt, custom_prompt_enabled}) => {  
  try {
    const result = await api.put('prompts/custom_prompt', { prompt, custom_prompt_enabled })

    if (result.status === 200 || result.status === 204 || result.status === 201) {
      return {
        success: true,
        data: result.data,
      }
    } else {
      return {
        success: false,
        error: result.data,
      }
    } 
  } catch (error) {
    return {
      success: false,
      error: error.message,
    }
  }

}